(function () {

    function initLanguageSelectors() {

        document.querySelectorAll('.announcement-language').forEach(selector => {

            if (selector.dataset.initialized) return;
            selector.dataset.initialized = 'true';

            const toggle = selector.querySelector('.announcement-language__toggle');
            const input = selector.querySelector('.announcement-language__input');
            const form = selector.querySelector('form');

            toggle.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                selector.classList.toggle('open');
            });

            selector.querySelectorAll('.announcement-language__option').forEach(option => {

                option.addEventListener('click', e => {

                    e.preventDefault();

                    input.value = option.dataset.language;

                    form.submit();

                });

            });

        });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLanguageSelectors);
    } else {
        initLanguageSelectors();
    }

    document.addEventListener('shopify:section:load', initLanguageSelectors);

})();